import Typography from "../Typography/Typography"
import styles from "./style.module.css"
import { Link, useNavigate } from "react-router-dom"
import { copyIcon } from "../../assets/svgs"
import { openXfacebookDark } from "../../assets/socials"
import { openXinstagramDark } from "../../assets/socials"
import { openXlinkedinDark } from "../../assets/socials"
import { openXtwitterDark } from "../../assets/socials"
import { openXyoutubeDark } from "../../assets/socials"
import AnimatedButton from "../AnimatedButton"

export const SuccessMessage = () => {

    const link = "https://openx.store/demo-shop";
    const navigate = useNavigate()

    //copy
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(`${link}`);
            alert('Text copied!');
        } catch (err) {
            console.error('Copy failed:', err);
        }
    };

    return (
        <>

            <div className={styles.container}>

                <div className={styles.congratsContainer}>

                    <div>
                        <Typography
                            variant="heading2"
                            className={styles.congrats}
                        >
                            Congratulations, your Store is Live
                        </Typography>
                    </div>

                    <div>
                        <Typography
                            variant="bodyLarge"
                            className={styles.congratsBody}
                        >
                            You’ve just opened your virtual doors to the world. Start sharing your link, attract visitors, and watch your creations shine.
                        </Typography>
                    </div>

                    <div className={styles.copyContainer}>
                        <div
                            className={styles.copyLink}
                        >
                            <Typography
                                weight="regular"
                                size="xl5"
                                fontFamily="satoshi"
                                // lineHeight=""
                                letterSpacing="trackingNormal"
                                className={styles.congrats}
                            >

                                <Link to={''}>
                                    {link}
                                </Link>

                            </Typography>
                            <div
                                style={{ cursor: "pointer" }}
                                onClick={handleCopy}
                            >
                                <img src={copyIcon} alt="copy-icon" />
                            </div>
                        </div>
                    </div>

                    <div className={styles.socialContainer}>
                        <div className={styles.socialLinks}>
                            <a href="hello#" className={styles.socialLink} aria-label="Twitter">
                                <img src={openXtwitterDark} alt="Twitter" width="20" height="20" />
                            </a>
                            <a href="hello#" className={styles.socialLink} aria-label="YouTube">
                                <img src={openXyoutubeDark} alt="YouTube" width="20" height="20" />
                            </a>
                            <a href="hello#" className={styles.socialLink} aria-label="Instagram">
                                <img src={openXinstagramDark} alt="Instagram" width="20" height="20" />
                            </a>
                            <a href="hello#" className={styles.socialLink} aria-label="LinkedIn">
                                <img src={openXlinkedinDark} alt="LinkedIn" width="20" height="20" />
                            </a>
                            <a href="hello#" className={styles.socialLink} aria-label="Facebook">
                                <img src={openXfacebookDark} alt="Facebook" width="20" height="20" />
                            </a>
                        </div>
                    </div>

                    <div className={styles.buttonContainer}>

                        <div className={styles.buttonGroup}>
                            <AnimatedButton
                            variant="primary"
                            type="button"
                                onClick={() => {
                                    // window.location.href = '/seller-dashboard';
                                    navigate('/seller-dashboard')
                                    
                                }}
                                className={styles.primaryButton}
                            >
                                <Typography
                                    variant="buttonText"
                                    fontFamily="satoshi"
                                    weight="regular"
                                    size="base"
                                    className={styles.primaryButtonText}>
                                    Go to dashboard
                                </Typography>
                            </AnimatedButton>
                        </div>

                    </div>

                    <div className={styles.line}>

                    </div>

                </div>

            </div>

        </>
    )
}